import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  ViewChild
} from '@angular/core';
import { NotificationPanelComponent } from '@zaoblako/web/shared/components/notification/panel/notification-panel.component';

@Component({
  standalone: true,
  selector: 'frm-informer-bottom-bar',
  templateUrl: './frm-informer-bottom-bar.component.html',
  styleUrls: ['./frm-informer-bottom-bar.component.scss'],
  imports: [CommonModule, NotificationPanelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrmInformerBottomBarComponent {
  @Input() public minimized = false;

  @ViewChild(NotificationPanelComponent) private notificationPanel?: NotificationPanelComponent;

  @HostListener('document:keydown', ['$event'])
  public onDocumentKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;
    const tag = target?.tagName?.toLowerCase();
    const inField =
      tag === 'input' ||
      tag === 'textarea' ||
      (target && 'isContentEditable' in target && (target as HTMLElement).isContentEditable);

    const isMetaK =
      (event.metaKey || event.ctrlKey) && (event.key === 'k' || event.key === 'K');
    if (isMetaK && !inField) {
      event.preventDefault();
      this.notificationPanel?.focusGlobalSearch();
      return;
    }

    if (event.key === 'Escape') {
      const active = document.activeElement as HTMLElement | null;
      if (
        active &&
        (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA') &&
        active.closest('.np-search')
      ) {
        active.blur();
      }
    }
  }
}
